import { getCurrentPath } from "@faire/web--source/common/Path";
import { route as confirmIdentityRoute } from "@faire/web-api--source/routes/confirm-identity";
import { matchPath } from "react-router-dom";
import { IDENTITY_VERIFICATION_SHOW_MODAL_QUERY_PARAM_VALUE } from "./consts";
/**
 * Whether we are currently in the identity verification / confirmation flow,
 * either in the intro/modal step or the core IDV flow.
 */ export var isIdentityVerificationModalOrRoute = function() {
    var path = getCurrentPath();
    return path.searchParams.get("SHOW_MODAL_QUERY_PARAM") === IDENTITY_VERIFICATION_SHOW_MODAL_QUERY_PARAM_VALUE || !!matchPath(path.pathname, confirmIdentityRoute);
};
